(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Reuse the theme's real submit button to retain variant, quantity and cart behaviour.
  if (!customElements.get('mg-description-cart')) {
    customElements.define('mg-description-cart', class extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => {
          this.button = this.querySelector('button');
          this.label = this.button.querySelector('span');
          this.productInfo = this.closest('product-info');
          if (!this.productInfo) return;

          this.onClick = () => {
            this.sync();
            if (!this.button.disabled && this.submitButton) this.submitButton.click();
          };
          this.button.addEventListener('click', this.onClick);
          this.observer = new MutationObserver(() => {
            cancelAnimationFrame(this.syncFrame);
            this.syncFrame = requestAnimationFrame(() => this.sync());
          });
          this.observer.observe(this.productInfo, {
            subtree: true,
            childList: true,
            characterData: true,
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'class']
          });
          this.sync();
        });
      }

      sync() {
        const form = document.getElementById(this.dataset.formId);
        this.submitButton = form && form.querySelector('[name="add"][type="submit"]');
        const description = this.nextElementSibling;
        const text = description ? (description.innerText || description.textContent || '').trim() : '';
        const wordCount = text ? text.split(/\s+/u).length : 0;
        const show = wordCount > Number(this.dataset.wordThreshold) && !!this.submitButton;
        const display = show ? '' : 'none';
        if (this.button.style.display !== display) this.button.style.display = display;

        const source = this.submitButton;
        const busy = !!source && (source.classList.contains('loading') || source.getAttribute('aria-busy') === 'true');
        const disabled = !source || source.disabled || source.getAttribute('aria-disabled') === 'true' || busy;
        if (this.button.disabled !== disabled) this.button.disabled = disabled;
        if (this.button.getAttribute('aria-busy') !== String(busy)) {
          this.button.setAttribute('aria-busy', String(busy));
        }
        if (source) {
          const sourceLabel = source.querySelector(':scope > span');
          const label = (sourceLabel || source).textContent.trim();
          if (this.label.textContent !== label) this.label.textContent = label;
        }
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        cancelAnimationFrame(this.syncFrame);
        if (this.observer) this.observer.disconnect();
        if (this.button && this.onClick) this.button.removeEventListener('click', this.onClick);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
